module.exports = "/_next/static/images/9ccadb1bc178f4a20ec72bf2a403f0ad-analysis-new.svg.webp";